/* global axios */
import ApiClient from './ApiClient';

// WhatsApp Cloud template management (US-WA-01) — fork feature.
// Kept out of the core inboxes.js API module so upstream changes there never
// collide with this feature.
class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`);
  }

  create(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, template);
  }
}

export default new WhatsappTemplatesAPI();
